import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import ParameterGroupDropdown from '../ParameterGroupDropdown'
import ParameterDataTypeDropdown from '../ParameterDataTypeDropdown'
import ParameterUnitPrefixesDropdown from '../ParameterUnitPrefixesDropdown'
import ParameterUnitsDropdown from '../ParameterUnitsDropdown'
import TextArea from '@/shared/Inputs/TextArea'
import { IParameter, TCreateParameterDTO } from '../../parameters.types'

interface IProps {
  parameter: IParameter | TCreateParameterDTO
  handleChange: (val: string | number, name: string) => void
}

const ParameterFormFields = ({ parameter, handleChange }: IProps) => {
  return (
    <div className="flex-lines gap16">
      <FormField label="Наименование" required>
        <TextInput name="name" onChange={handleChange} value={parameter.name} placeHolder="Введите наименование" />
      </FormField>
      <FormField label="ID" required>
        <TextInput name="sourceId" onChange={handleChange} value={parameter.sourceId} placeHolder="Введите ID" />
      </FormField>
      <FormField label="Расположение" required>
        <ParameterGroupDropdown name="groupId" onChange={handleChange} value={parameter.groupId} />
      </FormField>
      <FormField label="Тип данных" required>
        <ParameterDataTypeDropdown name="dataType" onChange={handleChange} value={parameter.dataType} />
      </FormField>
      <div className="inline-flex-gap gap16 width100">
        <FormField label="Префикс" fullWidth required>
          <ParameterUnitPrefixesDropdown
            name="unitPrefixId"
            onChange={handleChange}
            value={parameter.unitPrefixId}
            title="Выберите префикс"
          />
        </FormField>
        <FormField label="Единица измерения" fullWidth required>
          <ParameterUnitsDropdown
            name="unitId"
            onChange={handleChange}
            value={parameter.unitId}
            title="Выберите единицу измерения"
          />
        </FormField>
      </div>
      <FormField label="Комментарий">
        <TextArea name="comment" onChange={handleChange} value={parameter.comment} placeHolder="Введите комментарий" />
      </FormField>
    </div>
  )
}

export default ParameterFormFields
